export default __webpack_public_path__ + "static/media/buypending.41a83ce9.gif";